import { PopupModal } from "components/modals/ModalBox";
import React from "react";
import useButtonLoader from "hooks/useButtonLoader";
import { toastMessage } from "utils/toastMessage";
import { deleteNotificationApi } from "services/notification";

const DeleteNotification = ({
  selectedNotificationDetail,
  onClose,
  setNotificationList,
  deleteModel,
}) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");

  // change delete handler
  const changeDeleteHandler = async () => {
    try {
      setButtonLoader(true);

      const { data: responseData, status } = await deleteNotificationApi(
        selectedNotificationDetail._id
      );
      if (status === 200) {
        // Remove the deleted user from the list
        setNotificationList((prevList) =>
          prevList.filter(
            (notification) =>
              notification._id !== selectedNotificationDetail._id
          )
        );
        onClose();
        toastMessage(
          responseData.message,
          "success",
          "deleteAdminNotification"
        );
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={deleteModel}
        handleClose={onClose}
        content="Are you sure you want to Delete this notification?"
        title="Delete Notification"
        buttonLoader={buttonLoader}
        action={changeDeleteHandler}
      />
    </>
  );
};

export default DeleteNotification;
